import sanitizeHtml from "sanitize-html";
import "./Typography.scss";

const cleanHtml = (html: string) => {
  if (html) return { __html: sanitizeHtml(html) };
};

interface TypographyProps {
  children?: any,
  className?: string, 
  html?: string, 
  disabled?: boolean, 
  bold?: boolean,
  onClick?: any,
  secondary?: boolean
  light?: boolean
  center?: boolean
}

const colors = {
  orange: "#FE7C40",
  black: "#000000",
  grey: "#BDBDBD",
  darkerGrey: "#9D9D9D",
};

export const Header = (props: TypographyProps) => {
  const { children, className, disabled } = props;

  const styleColor = {
    "--color": disabled ? colors.grey : colors.orange,
  };

  return (
    <span
      //@ts-ignore
      style={styleColor}
      className={`typo-header ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};

export const Subheader = (props: TypographyProps) => {
  const { children, className, secondary, light, disabled } = props;

  const getColor = () => {
    if (disabled) 
      return colors.grey

    if (secondary)
      return colors.black

    return colors.orange
  }
  const styleColor = {
    "--color": getColor(),
    "--weight": light ? '400' : '800'
  };

  const propsFiltered = {
    ...props,
    light: null,
    secondary: null
  }

  return (
    <span
      //@ts-ignore
      style={styleColor}
      className={`typo-subheader ${className}`}
      {...propsFiltered}
    >
      {children}
    </span>
  );
};

export const Title = (props: TypographyProps) => {
  const { children, className, disabled, secondary } = props;

  const getColor = () =>
    secondary ? colors.orange : colors.black
  
  const styleColor = {
    "--color": disabled ? colors.grey : getColor(),
  };

  const propsFiltered = {
    ...props,
    secondary: null
  }

  return (
    <span //@ts-ignore
      style={styleColor}
      className={`typo-title ${className ? className : ''}`}
      {...propsFiltered}
    >
      {children}
    </span>
  );
};

export const Subtitle = (props: TypographyProps) => {
  const { children, className, disabled } = props;

  const styleColor = {
    "--color": disabled ? colors.darkerGrey : colors.black,
  };

  return (
    <span //@ts-ignore
      style={styleColor}
      className={`typo-subtitle ${className ? className : ''}`}
      {...props}
    >
      {children}
    </span>
  );
};


export const Text = (props: TypographyProps) => {
  const { children, className, html, disabled, bold } = props;
  const styleColor = {
    "--color": disabled ? colors.grey : colors.black,
  };

  const isBoldText = bold && children
  const htmlContent = html ?? ''

  return (
    <span
      //@ts-ignore
      style={styleColor}
      className={`typo-text ${className}`}
      dangerouslySetInnerHTML={cleanHtml(
        isBoldText ? `<b>${children}</b>` : htmlContent
      )}
    >
      {bold ? null : children}
    </span>
  );
};

export const Placeholder = (props: TypographyProps) => {
  const { children, className, disabled, onClick, bold, center } = props;

  const styleColor = {
    "--color": disabled ? colors.grey : colors.black,
  };

  const stylePointer = {
    cursor: props.onClick ? 'pointer' : 'auto'
  }

  const styleAlign = {
    textAlign: center ? 'center' : 'start'
  }

  const onClickPlaceholder = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <span
      //@ts-ignore
      style={{...styleColor, ...stylePointer, ...styleAlign}}
      className={`typo-placeholder ${className}`}
      dangerouslySetInnerHTML={cleanHtml(
        bold ? `<b>${children}</b>` : ''
      )}
      onClick={onClickPlaceholder}
    >
      {bold ? null : children}
    </span>
  );
};
